<script setup lang="ts">
  import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
  import { Button } from "@/components/ui/button";
  import type { FormDialogProps } from "./types";

  const props = withDefaults(defineProps<FormDialogProps>(), {
    isEditing: false,
    entityName: undefined,
    title: undefined,
    confirmLabel: "Save",
    loading: false,
    maxWidth: "425px",
    canSave: true,
  });

  const emit = defineEmits<{
    "update:open": [value: boolean];
    save: [];
    cancel: [];
  }>();

  const handleClose = () => {
    emit("update:open", false);
    emit("cancel");
  };
</script>

<template>
  <Dialog
    :open="props.open"
    @update:open="emit('update:open', $event)">
    <DialogContent
      class="font-sans max-h-[80vh] flex flex-col"
      :style="{ maxWidth: `${props.maxWidth}` }">
      <DialogHeader class="flex-shrink-0">
        <DialogTitle>
          {{ props.title ?? (props.isEditing ? `Edit ${props.entityName}` : `Create ${props.entityName}`) }}
        </DialogTitle>
      </DialogHeader>
      <div class="grid gap-4 py-4 overflow-y-auto flex-1">
        <slot />
      </div>
      <DialogFooter class="flex-shrink-0">
        <Button
          variant="outline"
          class="text-sm"
          :disabled="props.loading"
          @click="handleClose">
          Cancel
        </Button>
        <Button
          class="text-sm"
          :disabled="props.loading || !props.canSave"
          @click="emit('save')">
          {{ props.loading ? "Saving..." : props.confirmLabel }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
